'use client'

import dynamic from 'next/dynamic'
import { LoadingPlaceholder } from './LoadingPlaceholder'

export type { RichTextEditorProps } from './types'

export const RichTextEditor = dynamic(
  () => import('./RichTextEditor').then((mod) => mod.RichTextEditor),
  { ssr: false, loading: () => <LoadingPlaceholder /> }
)
